export enum DefaultFoldersEnum{
    ALL_CONTENT = 'ALL_CONTENT',
    UNCATEGORIZED = 'UNCATEGORIZED'
}
